<template>
  <div class="paper-package">
    <headers :title="title" @toGet="goSearh">
      <template slot="right-sum">
        <img class="search" src="@/assets/images/search.png" alt />
      </template>
    </headers>
    <div class="course-fitler">
      <van-dropdown-menu :active-color="$theme_color">
        <van-dropdown-item title="考试分类" ref="classify_id">
          <van-tree-select
            :items="items"
            :main-active-index="mainActiveIndex"
            :active-id="activeId"
            @click-nav="onClickNav"
            @click-item="onClickItem"
          />
        </van-dropdown-item>
        <van-dropdown-item title="考试类型" ref="exam_type">
          <ul class="course-sort">
            <li
              :class="searchParams.exam_type == item.key ? 'active':''"
              v-for="item in exam_type"
              :key="item.key"
              @click="selectType('exam_type',item.key)"
            >{{item.value}}</li>
          </ul>
        </van-dropdown-item>
        <van-dropdown-item title="考试状态" ref="start_status">
          <ul class="course-sort">
            <li
              :class="searchParams.start_status == item.key ? 'active':''"
              v-for="item in start_status"
              :key="item.key"
              @click="selectType('start_status',item.key)"
            >{{item.value}}</li>
          </ul>
        </van-dropdown-item>
        <!-- <van-dropdown-item title="参考状态" ref="done_status">
          <ul class="course-sort">
            <li
              :class="searchParams.done_status == item.key ? 'active':''"
              v-for="item in state"
              :key="item.key"
              @click="selectType('done_status',item.key)"
            >{{item.value}}</li>
          </ul>
        </van-dropdown-item> -->
      </van-dropdown-menu>
      <div class="filter2"
           @click="showFilter = true">
        <img src="@/assets/images/filter.png"
             alt="筛选">
      </div>
      <van-popup v-model="showFilter"
                 position="right">
        <div class="popup-content">
          <section class="box">
            <div>
              <div class="title">
                <span>参考状态</span>
              </div>
              <div class="content">
                <div class="btn"
                     :class="searchParams.done_status == item.key ? 'selected':''"
                     v-for="(item,index) in state"
                     :key="index"
                     @click="selectType('done_status',item.key)">{{item.value}}</div>
              </div>
            </div>
          </section>
        </div>
        <div class="popup-btn">
          <div class="btn"
               @click="onReset">重置</div>
          <div class="btn"
               @click="onOk">完成</div>
        </div>
      </van-popup>
    </div>
    <p v-if="searchParams.name" class="oto-title">"{{searchParams.name}}"搜索结果</p>
    <List
      ref="list"
      url="/api/app/exam/packageSimulation"
      :onGetdata="getList"
      :params="searchParams"
      :onFormatter="onFormatter"
      :showText="list.length>0"
      method="get"
    >
      <Card slot="item" :list="list" comType="Exam" :examType="searchParams.exam_type"></Card>
    </List>
  </div>
</template>

<script>
import headers from "@/components/Header";
import List from "@/components/List";
import Card from "./QuestionCard";
export default {
  name: "Exam",
  components: {
    headers,
    List,
    Card
  },
  data() {
    return {
      title: {
        name: "仿真模考"
      },
      state: [
        { key: "0", value: "全部" },
        { key: "1", value: "已做" },
        { key: "2", value: "未做" }
      ],
      start_status: [
        { key: "0", value: "全部" },
        { key: "2", value: "未开始" },
        { key: "1", value: "进行中" },
        { key: "3", value: "已结束" }
      ],
      exam_type: [
        { key: "0", value: "全部" },
        { key: "1", value: "模拟考试" },
        { key: "2", value: "正式考试" }
      ],
      searchParams: {
        exam_type: 0,
        done_status: 0,
        start_status: 0,
        name: "",
        init: function() {
          this.done_status = 0;
          this.start_status = 0;
          this.exam_type = 0;
        }
      },
      list: [],
      firstIn: 0,
      items: [],
      mainActiveIndex: 0,
      // 被选中元素的id
      activeId: "",
      firstIn: 0,
      showFilter: false
    };
  },
  created() {
    this.getClassify();
  },
  methods: {
    onFormatter(row) {
      row.forEach(item => {
        if (item.limit_time == -1) {
          item.limit_time = "无限制";
        } else {
          item.limit_time = parseInt(item.limit_time / 60) + "分钟";
          if (item.limit_time % 60) {
            item.limit_time = item.limit_time + (item.limit_time % 60) + "秒";
          }
        }
      });
    },
    goSearh() {
      this.$router.push({
        name: "Search",
        query: {
          name: "Exam"
        }
      });
    },
    selectType(name, val) {
      this.searchParams[name] = val;
      if(name == 'done_status'){} else{
        this.$refs[name].toggle();
        this.clearName();
        this.$refs.list.reset();
      }
    },
    getList(list) {
      this.list = list;
    },
    clearName() {
      if (this.searchParams.name) {
        this.searchParams.name = "";
      }
    },
    onClickNav(index) {
      this.mainActiveIndex = index;
      if (!this.items[index].children) {
        this.selectType("classify_id", this.items[index].id);
      }
    },
    onClickItem(data) {
      this.activeId = data.id;
      this.selectType("classify_id", data.id);
    },
    getClassify() {
      this.$http.get(`/api/app/exam/test/classify`).then(res => {
        res.rows.forEach(item => {
          item.text = item.label;
          item.children &&
            item.children.forEach(it => {
              it.text = it.label;
            });
        });
        res.rows.unshift({
          text: "全部",
          id: ""
        });
        this.items = res.rows;
      });
    },
    onReset () {
      this.searchParams.done_status = 0;
    },
    onOk () {
      this.$refs.list.reset();
      this.showFilter = false;
    },
  },
  activated() {
    if (!this.firstIn) {
      this.firstIn = 1;
      return;
    }
    if (this.$store.state.keywords) {
      this.searchParams.init();
      this.searchParams.name = this.$store.state.keywords;
      this.$store.commit("OTO_KEY");
    } else {
      this.clearName();
    }
    this.$refs.list.reset();
  }
};
</script>

<style lang='scss' scoped>
.paper-package {
  .search {
    width: 38px;
    height: 40px;
    margin-top: 20px;
  }
  .oto-title {
    font-size: 28px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(140, 140, 140, 1);
    padding-top: 30px;
    padding-left: 20px;
  }
  .course-fitler{
    box-shadow:0 0.26667vw 1.6vw rgba(100,101,102,.08);
    .van-dropdown-menu{
      width: 640px;
    }
    /deep/ .van-dropdown-menu__bar{
      box-shadow: 0 0 0 0;
    }
  }
}
  .filter2 {
    position: fixed;
    right: 0px;
    z-index: 999;
    font-size: 30px;
    line-height: 80px;
    height: 84px;
    text-align: center;
    width: 110px;
    float: right;
    color: #323233;
    background-color: #fff;
    img {
      width: 34px;
      vertical-align: middle;
    }
  }

  .van-popup {
    z-index: 999999 !important;
    height: 100%;
    width: 629px;
    .popup-content {
      background-color: #fff;
      position: absolute;
      top: 0;
      bottom: 100px;
      overflow: scroll;
      width: 100%;
      .box {
        margin-left: 36px;
        margin-right: 36px;
        margin-top: 57px;
        padding: 0;
        font-size: 28px;
        .title {
          font-weight: bold;
          height: 26px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .arrow {
            display: inline-block;
            width: 80px;
            height: 50px;
            margin-right: 5px;
            line-height: 50px;
            text-align: right;
          }
        }
        .content {
          font-size: 25px;
          margin-top: 10px;
          margin-bottom: 62px;
          display: flex;
          justify-content: flex-start;
          flex-flow: wrap row;
          align-content: stretch;
          .btn {
            width: 170px;
            height: 72px;
            border-radius: 4px;
            margin-top: 10px;
            box-sizing: border-box;
            background-color: #f5f5f5;
            color: #666666;
            font-size: 24px;
            // 文字溢出
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;
            line-height: 72px;
            &:nth-child(3n-1) {
              margin-left: 20px;
              margin-right: 20px;
            }
          }
          .btn.selected {
            background-color: $theme_color;
            color: #fff;
          }
        }
      }
      .limit-height {
        height: 180px;
        overflow: hidden;
      }
    }
    .popup-btn {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 90px;
      display: flex;
      box-shadow: 0px 0px 7px 0px rgba(2, 108, 204, 0.06);
      .btn {
        width: 50%;
        // height: 100%;
        font-size: 30px;
        // border: 1px solid #f8f8f8;
        text-align: center;
        line-height: 90px;
        color: #333;
        background-color: #fff;
      }

      .btn:nth-of-type(2) {
        background-color: $theme_color;
        border-color: $theme_color;
        color: #fff;
      }
    }
  }
</style>
